const NOTIFICATIONS_STORAGE_KEY = "portalNotifications";

type NotificationsState = Record<string, "hide">;

const encode = (state: NotificationsState): string =>
  Array.from(new TextEncoder().encode(JSON.stringify(state)))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");

const decode = (value: string): NotificationsState => {
  try {
    const bytes = value.match(/.{2}/g)?.map((hex) => parseInt(hex, 16)) ?? [];
    const parsed = JSON.parse(new TextDecoder().decode(new Uint8Array(bytes)));

    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
};

const read = (): NotificationsState => {
  try {
    const value = localStorage.getItem(NOTIFICATIONS_STORAGE_KEY);

    return value ? decode(value) : {};
  } catch {
    return {};
  }
};

export const isNotificationHidden = (id: string): boolean =>
  read()[id] === "hide";

export const hideNotification = (id: string): void => {
  try {
    localStorage.setItem(
      NOTIFICATIONS_STORAGE_KEY,
      encode({ ...read(), [id]: "hide" }),
    );
  } catch {
    // Storage unavailable: the banner is only dismissed for this session
  }
};
